import { render } from "./PageFormulirBerasa.vue?vue&type=template&id=10ca0413"
import script from "./PageFormulirBerasa.vue?vue&type=script&lang=js"
export * from "./PageFormulirBerasa.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__